import React from "react"
import { withStyles } from '@material-ui/core';
import reportImage from "images/analytics_view.png"
import moment from "moment"
import Drawer from '@material-ui/core/Drawer';
import DrawerBody from "./drawerBody"
import VerticalMenu from "../../Components/menu"

const styles = () => ({
  super: {
    marginTop: "25px",
    marginRight: "25px"
  },
  imageStyle: {
    width: "256px",
    height: "221px",
    cursor: "pointer"
  },
  reportDetails: {
    fontSize: 16,
    lineHeight: "20px",
    fontWeight: 600,
    marginTop: 8,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: 208
  },
  reportName: {
    fontSize: 12,
    lineHeight: "18px",
    color: 'rgba(51, 51, 51, 0.5)',
    marginTop: 2
  },
  subDetails: {
    color: 'rgba(51, 51, 51, 0.7)',
    fontSize: 12,
    lineHeight: "18px",
    fontWeight: 600,
    marginTop: 2
  },
  subDetailsProperty: {
    color: 'rgba(51, 51, 51, 0.7)',
    fontSize: 12,
    lineHeight: "18px",
    fontWeight: 600,
    marginTop: 2,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: 208
  },
  seeAll: {
    textDecoration: "underline",
    cursor: "pointer"
  },
  menuIcon: {
    position: "absolute",
    right: 0,
    top: -12
  },
  details: {
    position: 'relative'
  }
})




const Report = ({ report, classes, allCampaigns, propertiesOfOrg, handlePreviewClick, showNotification, subOrgDetails }) => {
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [drawerData, setDrawerData] = React.useState();

  React.useEffect(() => {
    parseReportData(JSON.parse(report.params));
  }, [report])

  const parseReportData = (params) => {
    let propertiesName = [];
    let campaignsName = [];
    let activeStatusValues;
    let referredStatusValues;
    let leasedStatusValues;
    let typeStatusValue;

    if (params.property_ids) {
      for (let i = 0; i < params.property_ids.length; i++) {
        let property = propertiesOfOrg.find(e => e.id == params.property_ids[i])
        if (property) {
          propertiesName.push(property.value)
        }
      }
    }

    if (params.campaigns_id) {
      for (let i = 0; i < params.campaigns_id.length; i++) {
        let campaign = allCampaigns.find(e => e.id == params.campaigns_id[i])
        if (campaign) {
          campaignsName.push(campaign.title)
        }
      }
    }


    if (params.active_status) {
      if (params.active_status == "all") {
        activeStatusValues = ["Active", "Inactive"]
      } else {
        let value = params.active_status == "active" ? "Active" : "Inactive";
        activeStatusValues = [value]
      }
    }

    if (params.referred_status) {
      if (params.referred_status == "all") {
        referredStatusValues = ["Referred", "Not Referred"]
      } else {
        let value = params.referred_status == "not_referred" ? "Not Referred" : "Referred";
        referredStatusValues = [value]
      }
    }

    if (params.type_status) {
      typeStatusValue = params.type_status == "leased" ? ["Leased"] : params.type_status == "enrolled" ? ['Residents'] : ['Friends']
    }

    if (params.leased_status) {
      if (params.leased_status == "all") {
        leasedStatusValues = ["Yes", "No"]
      } else {
        leasedStatusValues = [params.leased_status]
      }
    }

    setDrawerData({
      propertiesName: propertiesName,
      campaignsName: campaignsName,
      activeStatusValues,
      referredStatusValues,
      leasedStatusValues,
      typeStatusValue,
      range_label: params.range_label
    })
  }

  const handleReportClick = () => {
    handlePreviewClick(report)
  }


  const toggleDrawer = () => {
    setOpenDrawer(!openDrawer)
  }

  if (!drawerData) {
    return null
  }

  return (
    <div className={classes.super}>
      <img src={reportImage} className={classes.imageStyle} onClick={handleReportClick} />
      <div className={classes.details}>
        <div className={classes.menuIcon}>
          <VerticalMenu reportData={report} showNotification={showNotification} subOrgDetails={subOrgDetails} />
        </div>
        <div className={classes.reportDetails}>{report.name}</div>
        <div className={classes.reportName}>{report.analyzeObject}</div>
        <div className={classes.subDetails}>Date: {drawerData.range_label}</div>
        <div className={classes.subDetailsProperty}>Property: {drawerData.propertiesName.length == 0 ? "None" : drawerData.propertiesName.length == 1 ? drawerData.propertiesName[0] : `${drawerData.propertiesName[0]} & ${drawerData.propertiesName.length - 1} others`}</div>
        <div className={`${classes.subDetails} ${classes.seeAll}`} onClick={toggleDrawer}>See All</div>
      </div>
      <Drawer
        anchor={'right'}
        open={openDrawer}
        onClose={toggleDrawer}
      >
        <DrawerBody title={report.name} onClose={toggleDrawer} date={[drawerData.range_label]}  {...drawerData} />
      </Drawer>
    </div>
  )
}

export default withStyles(styles)(Report)